<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolFwr2018_2d00_P160_2erKaskade"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolFwr2018_2d00_P160 from '@/device-products/ResolFwr2018_2d00_P160.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: ResolFwr2018_2d00_P160, deviceLabel: 'Codierung 0: TUX', props: { leiterplattenCodierung: 0 } },
      { id: 1, component: ResolFwr2018_2d00_P160, deviceLabel: 'Codierung 1: VFS', props: { leiterplattenCodierung: 1 } },
    ],
  }),
};
</script>

<style>

</style>
